/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* See [Inventory Attribute Service](https://docs.xandr.com/bundle/xandr-api/page/inventory-attribute-service.html) in Xandr's documentation.
*/
export class V3InventoryAttributeTarget {
    /**
    * ID of the inventory attribute.
    */
    'id'?: number;
    /**
    * Name of the inventory attribute.
    */
    'name'?: string;
    /**
    * Whether the target has been deleted or not
    */
    'deleted'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "deleted",
            "baseName": "deleted",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3InventoryAttributeTarget.attributeTypeMap;
    }

    public constructor() {
    }
}

